import { combineReducers } from "redux";

import data from "./_data";
import fetching from "./_fetching";

export default combineReducers({ data, fetching });
